/* eslint-disable prefer-const */
/* eslint-disable no-unused-vars */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/rules-of-hooks */
import moment from "moment";
import XLSX from "sheetjs-style";
import config from '../config/config';
import { DATE_FORMAT , BASE_URLS,MESSAGE_TYPE} from '../constants'; // Added for CHG0073013
import apiService from "../apis/apiService";
import LeftNav from "../LeftNav";


const { API_BASE_URL } = config;

// eslint-disable-next-line import/prefer-default-export
export const logoutAndClearData = () =>
  {window.location.href = '/'; } 
  // keycloak.logout().then(() => {
  //   window.keycloak = null;
  //   window.location.href = '/';
  // });


  export const getDatesForRange = (startDate, endDate) => {
    const startDateCopy = moment(startDate, DATE_FORMAT.ISO);
    const endDateCopy = moment(endDate, DATE_FORMAT.ISO);
  
    const dates = [];
    while (startDateCopy.isSameOrBefore(endDateCopy, 'day')) {
      dates.push(moment(startDateCopy));
      startDateCopy.add(1, 'days');
    }
    return dates;
  };

export const getISTTime = unixTimeInSeconds =>
  moment.unix(unixTimeInSeconds).format('hh:mm:ssa');

export const getApiRelativeUrl = url =>
  url.substring(API_BASE_URL.length)

export const handleKeyPress = ({ event, callback }) => {
  const inputVal = event?.target?.value.trim();
  if (typeof callback === "function") {
    if (event?.key === 'Enter' || inputVal?.length === 8) {
      callback(inputVal);
    }
  } else {
    console.error("Callback is not a function", callback);
  }
}

export const parseLocalDate = (dateStr) => {
  const [year, month, day] = dateStr.split('-').map(Number);
  return { year, month, day }; // month is already 1-based
};

export const safeRedirect = (url) => {
  const parsed = new URL(url);
  const trustedHosts = new Set([
    "login.microsoftonline.com",
  ])
  if (
    parsed.protocol !== "https:" ||
    !trustedHosts.has(parsed.hostname)
  ) {
    throw new Error("Unsafe redirect");
  }
  window.location.assign(parsed.toString());
}

export const azureLoginPage = () => {
  try {
    fetch(`${BASE_URLS}home/api/auth/azure/login/`,{credentials:'include'})
    .then((response) => {
      if (!response.ok) {
        throw new Error('Failed to initiate Azure login');
      }
      return response.json();
    })
    .then((data) => {  
      if (data?.login_url) {
        safeRedirect(data.login_url);
      } else {
        throw new Error('No login_url provided in the response');
      }
    })
    .catch((error) => {
      console.error('Error initiating Azure login:', error);
    });
  } catch (error) {
    console.error("Error initiating Azure login:", error);
  }
};
// Check cookie session login

export const checkCookieAndLogin = async()=>{
  try {
    const response = await apiService.checkCookieAndLogin()
    if(response?.isAuthenticated){
      return
    }
    azureLoginPage()
  } catch (error) {
    console.error(error)
    azureLoginPage()
  }
}

export const azureLogout = (dispatch, logoutUser) => {
  window.location.href = `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}/oauth2/v2.0/logout`;
  dispatch(logoutUser); 
}

export const handleLogout = async (dispatch) => {
  try {
    const sessionId = sessionStorage.getItem('sessionId');
    if (!sessionId) {
      console.warn('No sessionId found in sessionStorage.');
    }
    const payload = {
      session_id: sessionId
    };
   await apiService.sessionLogout(payload, dispatch);  
  } catch (error) { 
    console.error('Logout failed:', error);
  } finally{
    sessionStorage.clear() 
  }
};


const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
    animation: 'fadeInOverlay 0.3s ease forwards',
  },
  popup: {
    backgroundColor: '#fff',
    padding: '2.5rem 3rem',
    borderRadius: '8px',
    boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
    textAlign: 'center',
    minWidth: '320px',
    animation: 'fadeInPopup 0.4s ease forwards',
    transform: 'translateY(-20px)',
  },
  heading: {
    margin: '0 0 1rem',
    fontSize: '1.5rem',
  },
  message: {
    margin: '0 0 1.5rem',
    fontSize: '1.125rem',
    color: '#444',
  },
  button: {
    padding: '0.6rem 2rem',
    fontSize: '1rem',
    backgroundColor: '#0078D4',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  },
};

// Add keyframes as a global style or in a CSS file
const globalStyles = `
  @keyframes fadeInOverlay {
    from {opacity: 0;}
    to {opacity: 1;}
  }

  @keyframes fadeInPopup {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  button:hover {
    background-color: #005a9e;
  }
`;

export const SessionExpiredPopup = ({ isOpen, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <>
      <style>{globalStyles}</style>
      <div style={styles.overlay}>
        <div style={styles.popup}>
          <h2 style={styles.heading}>Session Expired</h2>
          <p style={styles.message}>Your session has expired. Please log in again.</p>
          <button onClick={onConfirm} style={styles.button} type="button">Login</button>
        </div>
      </div>
    </>
  );
};

export const downloadExcel = (headers, keys, data) => {
  const updatedData = data.map((item, index) => ({ id: index + 1, ...item }));

  const exportData = updatedData.map(row => {
    let obj = {};
    keys.forEach((key, i) => {
      obj[headers[i]] = row[key];
    });
    return obj;
  });

  const sheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, sheet, "Sheet1");

  XLSX.writeFile(workbook, "Budget_Exceeded_Data.xlsx");
};

export const isSameMonthYear = (d1, d2) =>
  d1?.getMonth() === d2?.getMonth() &&
  d1?.getFullYear() === d2?.getFullYear();

export const isWithinOpenBookingWindow = (bookingDate, appliedDate) => {
  const bookingYM =
    bookingDate?.getFullYear() * 12 + bookingDate?.getMonth();
  const appliedYM =
    appliedDate?.getFullYear() * 12 + appliedDate?.getMonth();
  return appliedYM === bookingYM || appliedYM === bookingYM + 1;
};

export const isAfterGraceCutoff = (approvalDate, deletionDate) => {
  const cutoff = new Date(
    approvalDate?.getFullYear(),
    approvalDate?.getMonth(),
    5,
    23, 59, 59, 999 // Open peroid window cutoff is 5th of the month at 11:59:59.999 PM
  );

  return deletionDate > cutoff;
};

export const canDeleteBooking = (row) => { 
  const bookingDate = new Date(row?.date);
  const bookingAppliedDate = new Date(row?.applied_date);
  const approvalDate = row?.approval_date
    ? new Date(row?.approval_date)
    : null;
  const deletionDate = new Date();
  if(row?.lock_status === 'LOCK'){
    return false
  }
  if(!isWithinOpenBookingWindow(bookingDate, bookingAppliedDate) && approvalDate === null && row.lock_status === 'LOCK' ){
    return false
  }
  if(row.lock_status === 'OPEN'){
  //   // NOT approved → ALWAYS ALLOW
  if (!approvalDate) return true;
  if (!isWithinOpenBookingWindow(bookingDate, bookingAppliedDate)) {
    return false;
  }
  // Deletion month must equal approval month
  if (!isSameMonthYear(approvalDate, deletionDate)) {
    return false;
  }

  // Approval must NOT be in booking month
  if (isSameMonthYear(approvalDate, bookingDate)) {
    return true;
  }

  // Must be within grace cutoff (≤ 5th of approval month)
  if (isAfterGraceCutoff(approvalDate, deletionDate)) {
    return false;
  }
    return true
  }
  return true;
};

export const downloadFileFromUrl = async (fileUrl, fileName = "download") => {
  try {
    if (!fileUrl) {
      throw new Error("File URL is missing");
    }
    // Fetch file as blob (important for presigned URLs)
    const response = await fetch(fileUrl);
    if (!response.ok) {
      throw new Error("Failed to fetch file");
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("File download failed:", error);
    throw error; 
  }
};

// Payload validation


export const sanitizeNumeric = (value, maxLength = 8) => {
  if (!value) return "";

  const stringValue = value.toString();

  if (stringValue.includes(",")) {
    return stringValue
      .split(",")
      .map(item => item.replace(/\D/g, "").slice(0, maxLength))
      .filter(Boolean)
      .join(",");
  }

  return stringValue
    .replace(/\D/g, "")
    .slice(0, maxLength);
};
export const sanitizeCoCodeNumeric = (value, maxLength=4) => {
  if (!value) return "";

  return value
    .toString()
    .replace(/\D/g, "")   // remove non-digits
    .slice(0, maxLength); // enforce length
};

// Changes Start for CHG0073013
export const validateExcelFile = (
  event,
  inputRef,
  setSelectedFile,
  showPopup,
  allowedExtensions = ["xlsx"],
) => {
  const file = event?.target?.files?.[0];
  if (!file) {
    showPopup({
      type: MESSAGE_TYPE.INFORMATION,
      contextText: MESSAGE_TYPE.INFORMATION,
      info: "Please select File",
    });

    // eslint-disable-next-line no-param-reassign
    inputRef.current.value = null;
    setSelectedFile(null);
    return false;
  }

  const ext = file.name.split(".").pop().toLowerCase();
 console.log("ext", ext);
 
 if (!allowedExtensions.includes(ext)) {
  showPopup({
    type: MESSAGE_TYPE.INFORMATION,
    contextText: MESSAGE_TYPE.INFORMATION,
    info: `Please select ${allowedExtensions.join(", ")} file type`,
  });

  if (inputRef?.current) {
     // eslint-disable-next-line no-param-reassign
    inputRef.current.value = null;
  }

  setSelectedFile(null);
  return false;
}

  // Max size: 5 MB
  const maxSize = 5 * 1024 * 1024;

  if (file.size > maxSize) {
    showPopup({
      type: MESSAGE_TYPE.INFORMATION,
      contextText: MESSAGE_TYPE.INFORMATION,
      info: "File size should not exceed 5 MB",
    });
 // eslint-disable-next-line no-param-reassign
    inputRef.current.value = null;
    setSelectedFile(null);
    return false;
  }

  setSelectedFile(file);
  return file;
};
// Changes END for CHG0073013
